/**
 * IMPORTANT!
 *
 * In order for this script to function properly it needs to be executed after any other DOM manipulation script
 * which could remove the click handlers or create new elements which wouldn't be handled by this script.
 */
;(function() {
  let fauxAnchorContainers = document.querySelectorAll('[data-faux-anchor]')

  if (!fauxAnchorContainers.length) {
    return
  }
  fauxAnchorContainers.forEach(container => {
    let anchor = container.querySelector('a')
    let href = anchor ? anchor.getAttribute('href') : null

    container.style.cursor = 'pointer'

    if (!href) {
      return
    }
    container.addEventListener('click', function(e) {
      e.preventDefault()
      // Need to deal with recirculation tracking
      if (anchor.getAttribute('data-linktype') === 'recirculation') {
        let dataLayer = window.dataLayer || []

        dataLayer.push({
          dL_navHeading: anchor
            .getAttribute('data-navheading')
            .toLowerCase()
            .trim(),
          dL_clickURL: href,
          dL_clickText: anchor.text.toLowerCase().trim(),
          event: 'e_navRecirculation'
        })
      }

      if (anchor.getAttribute('target')) {
        window.open(href)
      } else {
        window.location = href
      }
    })
  })
})()
